import { onBeforeUnmount, watch } from "vue";

const OPEN_POPUP_BUTTON = [
    "popover-panel",
    "menu-items",
    "listbox-options",
    "combobox-options",
]
    .map((id) => `[aria-expanded="true"][aria-controls^="headlessui-${id}"]`)
    .join(", ");

const openModals = [];

const openPopupButton = () => {
    const buttons = [...document.querySelectorAll(OPEN_POPUP_BUTTON)];
    const topDialog = [...document.querySelectorAll("[role=dialog]")].at(-1);

    if (topDialog) {
        return buttons.filter((button) => topDialog.contains(button)).at(-1);
    }

    return buttons.at(-1);
};

export const closeTopOverlay = () => {
    const button = openPopupButton();

    if (button) {
        button.click();
        return true;
    }

    const close = openModals.at(-1);

    if (!close) return false;

    close();
    return true;
};

export function useBackDismiss(isOpen, close) {
    const remove = () => {
        const index = openModals.indexOf(close);

        if (index !== -1) openModals.splice(index, 1);
    };

    watch(
        isOpen,
        (open) => {
            remove();
            if (open) openModals.push(close);
        },
        { immediate: true }
    );

    onBeforeUnmount(remove);
}
